<template>
  <div class="signin">
    <div class="signin__wrap">
      <div class="signin__card">
        <div class="signin__head">
          <div class="signin__logo">S</div>
          <h1 class="signin__title">Iniciar sesión</h1>
          <p class="signin__sub">Ingresá a tu panel de gestión Sartor.</p>
        </div>

        <v-alert
          v-if="creationAlert.show"
          :type="creationAlert.type"
          text
          dense
          dismissible
          class="signin__alert rounded-lg"
          @input="creationAlert.show = $event"
          >
          {{ creationAlert.msg }}
        </v-alert>

        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="signInUser"
          >
          <v-text-field
            v-model="user.email"
            :rules="emailRules"
            :label="$t('field.email')"
            type="email"
            outlined
            class="rounded-lg signin__field"
            required
            >
            <template v-slot:prepend-inner>
              <hero-icon :icon="EnvelopeIcon" :size="20" class="signin__icon" />
            </template>
          </v-text-field>

          <v-text-field
            v-model="user.password"
            :rules="passwordRules"
            :label="$t('field.password')"
            type="password"
            validate-on-blur
            outlined
            class="rounded-lg signin__field"
            required
            >
            <template v-slot:prepend-inner>
              <hero-icon :icon="LockClosedIcon" :size="20" class="signin__icon" />
            </template>
          </v-text-field>

          <v-btn
            :disabled="!valid"
            color="accent"
            depressed
            block
            large
            type="submit"
            class="rounded-lg signin__btn"
            >
            {{ $t("action.signin") }}
          </v-btn>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SigninUser } from "../graphql/mutations/user";
import { Email, Password } from "../utils/rules";
import { TokenService } from "../services/storageService";
import HeroIcon from "@/components/shared/HeroIcon";
import EnvelopeIcon from "heroicons/24/outline/envelope.svg";
import LockClosedIcon from "heroicons/24/outline/lock-closed.svg";

export default {
  name: "sign-in",

  components: { HeroIcon },

  data() {
    return {
      EnvelopeIcon,
      LockClosedIcon,
      creationAlert: { show: false },
      valid: false,
      user: {
        email: "",
        password: ""
      },
      emailRules: Email,
      passwordRules: Password
    };
  },

  methods: {
    async signInUser() {
      if (!this.valid) {
        return;
      }
      this.$apollo
        .mutate({
          mutation: SigninUser,
          variables: {
            input: {
              credentials: this.user
            }
          }
        })
        .then(res => {
          TokenService.saveToken(res.data.signIn.token);
          this.$router.push(this.$route.query.redirect || "/");
        })
        .catch(errors => {
          let error = errors.graphQLErrors[0].extensions;
          this.creationAlert = {
            type: "error",
            msg: this.$t(`error.${error.field}.${error.message}`),
            show: true
          };
        });
    }
  }
};
</script>

<style scoped>
.signin__wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.signin__card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #ece7de;
  border-radius: 16px;
  padding: 38px 34px;
  box-shadow: 0 30px 60px -40px rgba(40, 33, 20, 0.4);
}
@media (max-width: 480px) {
  .signin__card { padding: 28px 22px; }
}

.signin__head { text-align: center; margin-bottom: 26px; }
.signin__logo {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #b52118;
  color: #fff;
  font-weight: 700;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}
.signin__title { font-size: 23px; font-weight: 700; color: #1a1814; margin: 0; }
.signin__sub { font-size: 13.5px; color: #756f64; margin: 6px 0 0; }

.signin__alert { margin-bottom: 14px; }
.signin__icon { color: #a39a8c; margin-right: 6px; align-self: center; }
.signin__btn { margin-top: 6px; letter-spacing: 0.02em; }

/* rounded outlined inputs (Vuetify draws the border on a <fieldset>) */
.signin__field >>> fieldset { border-radius: 10px; }
.signin__field >>> .v-input__slot { transition: border-color 0.15s ease; }
</style>
